import { motion } from 'framer-motion';
import React from 'react';
import { FiPlus } from 'react-icons/fi';
import { sideModalAnimVariants } from '../../../constants/animationVariants';
import SectionHeader from '../Titles/SectionHeader';

const SideParentModal = ({
  children,
  headerText,
  customWidthClass,
  onClick,
  hideCloseButton,
}: {
  children: React.ReactNode;
  headerText: string;
  customWidthClass?: string;
  onClick: () => void;
  hideCloseButton?: boolean;
}) => {
  // rendering side parent modal component here
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className='fixed h-screen w-screen left-0 top-0 z-[9999] bg-black/25 backdrop-blur-md'
    >
      <div className='size-full'>
        <motion.div
          className={`grid grid-rows-[40px_1fr] relative pt-6 w-full h-full bg-white ml-auto md:rounded-l-xl z-20 ${
            customWidthClass ? customWidthClass : 'md:w-[650px] lg:w-[750px]'
          }`}
          variants={sideModalAnimVariants}
          initial='hidden'
          animate='visible'
          exit='exit'
        >
          {!hideCloseButton ? (
            <button
              onClick={onClick}
              className='absolute right-3 md:right-5 top-3 text-legal-dark-blue hover:text-base-red duration-300 z-30'
            >
              <FiPlus className='rotate-45 h-8 w-8' />
            </button>
          ) : null}

          <div className='px-3 relative z-20'>
            <SectionHeader headerText={headerText} />
          </div>

          <div className='overflow-y-scroll px-3 py-6'>{children}</div>
        </motion.div>
      </div>

      <div onClick={onClick} className='fixed left-0 top-0 h-full w-full'></div>
    </motion.div>
  );
};

export default SideParentModal;
